<template>
    <div id="sectorFilter" >
      <!-- <b-form-group class="row d-inlin justify-content-end" v-slot="{ ariaDescribedby }">
        <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" value="all_sectors">Todos os setores</b-form-radio>
        <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby"  value="management_sectors">Setores de manejo</b-form-radio>
      </b-form-group> -->
    <!-- <b-form-select
      class="form-controlform-control-sm select"
        v-model="selected"
        
      >
      <b-options></b-options>
    </b-form-select> -->
    <b-dropdown class="customDropdown responsive" size="sm" variant="none">
      <template #button-content class="button">
        <component class="icon pr-4" :is="selected.icon"></component>
       <span class="dropdownText">{{selected ? selected.text : 'Selecione uma opção'}}</span> 

      </template>
      <b-dropdown-item class="w-100 " v-for="option in options" :key="option.value" @click="select(option)">
        <component class="icon pr-4" :is="option.icon"></component> {{option.text}}
      </b-dropdown-item>
    </b-dropdown>
    </div>
  </template>
</template>

<script>
export default {
  data() {
    return {
      selected:{
        text:"Todos os setores",
        value: "all_sectors",
        icon: "sector-icon"
      },
      options: [
        { value: "all_sectors", text: "Todos os setores", icon: "sector-icon" },
        { value: "management_sectors", text: "Setores de manejo", icon: "code-not-equal-icon"  },
        { value: "simple_sectors", text: "Setores sem manejo", icon: "code-equal-icon"  }
      ],
    };
  },
  watch:{
   selected:{
    handler(newValue){
      console.log("aq")
      this.$emit("setFilter", newValue.value);
    }
    
   }
  },
  methods: {
    select(option) {
      this.selected = option;
      console.log(this.selected)
    },
  },
};
</script>
<style scoped>
.customDropdown {
display: flex;
text-align: left !important;
align-items: center;
  text-align: left;  
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-color: #fff;
  color: #495057;
}
.button{
 
  display: flex !important;
  align-items: center;
  justify-content: flex-start;
}
.icon{
  color: #e07f52;
  font-size: 1rem;
}
@media (max-width: 992px) {
  #sectorFilter{
    margin-top: 0.5em;
  }
}

</style>
